module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/zip-1ead5aed0c0cd24785b4e2bdd92274a2.svg";